import React, { lazy } from 'react';
import { PriceDisplay } from './PriceDisplay';
import { CTAButton } from './CTAButton';
const bonuses = [{
  num: 1,
  title: 'Lista de Compras Inteligente',
  desc: 'Comprá en 15 minutos sin olvidar nada ni gastar de más.',
  value: 18990,
  image: 'https://cdn.magicpatterns.com/uploads/jnvSWAQ9z2Pn2sEUWtm4th/Bono_1.png'
}, {
  num: 2,
  title: 'Manual de Congelación',
  desc: 'Congelá sin arruinar sabor ni textura.',
  value: 14990,
  image: 'https://cdn.magicpatterns.com/uploads/eXmxymfNKia1WV79HxYY2h/Bono_2.png'
}, {
  num: 3,
  title: 'Guía Anti-Caos de Cocina',
  desc: 'Cociná 2 horas sin ensuciar toda la cocina.',
  value: 16990,
  image: 'https://cdn.magicpatterns.com/uploads/9zYkkpG67vU68sLPZxTxUy/Bono_3.png'
}, {
  num: 4,
  title: 'Planificador Semanal',
  desc: 'Organizá tus comidas sin pensar cada día qué hacer.',
  value: 12990,
  image: 'https://cdn.magicpatterns.com/uploads/eJVL9jtUkpCzUJU9LPukmK/Bono_4.png'
}, {
  num: 5,
  title: 'Calculadora de Porciones Exactas',
  desc: 'Cociná la cantidad justa sin desperdicio.',
  value: 15990,
  image: 'https://cdn.magicpatterns.com/uploads/bkEmyuBdt5CCiCNT7g3vrd/Bono_5.png'
}, {
  num: 6,
  title: 'Recalentado Perfecto',
  desc: 'Recalentá sin que quede seco o aguado.',
  value: 11990,
  image: 'https://cdn.magicpatterns.com/uploads/mYKPxfrsD2octbEkLCAsrA/Bono_6.png'
}, {
  num: 7,
  title: 'Control del Delivery',
  desc: 'Eliminá el impulso de pedir comida sin darte cuenta.',
  value: 13990,
  image: 'https://cdn.magicpatterns.com/uploads/jbZzNomMHN2zn7VfMNpapA/Bono_7.png'
}];
export function BonusSection() {
  return <section className="py-5 md:py-7 px-4 bg-[#F7F5F0] text-text-primary" data-id="element-27">
      <div className="max-w-2xl mx-auto" data-id="element-28">
        {/* Section Header */}
        <div className="text-center mb-4 md:mb-5" data-id="element-29">
          <div className="inline-flex items-center gap-2 bg-primary text-white px-3 py-1.5 rounded-full mb-3 md:mb-4" data-id="element-30">
            <span className="text-base" data-id="element-31">🎁</span>
            <span className="text-xs md:text-sm font-bold uppercase tracking-wide" data-id="element-32">
              7 Bonos Exclusivos Si Ordenás Hoy
            </span>
          </div>
        </div>

        {/* Bonus Cards - HORIZONTAL LAYOUT */}
        <div className="space-y-3 md:space-y-4 mb-5 md:mb-6" data-id="element-33">
          {bonuses.map((bonus, i) => <div key={i} className="bg-white rounded-2xl overflow-hidden border border-black/10 shadow-sm flex flex-row p-3 md:p-4 gap-3 md:gap-4 items-center" style={{
          minHeight: '136px'
        }} data-id="element-34">
              {/* Image Area — fixed dimensions prevent CLS */}
              <div className="relative shrink-0 rounded-xl overflow-hidden bg-[#F7F5F0] border border-black/5" style={{
            width: '112px',
            height: '112px'
          }} data-id="element-35">
                <img src={bonus.image} alt={`Bonus ${bonus.num} — ${bonus.title}`} className="w-full h-full object-cover" loading="lazy" decoding="async" width={144} height={144} data-id="element-36" />
              </div>

              {/* Content Area */}
              <div className="flex-1" data-id="element-37">
                {/* Number Badge + Title */}
                <div className="flex items-start gap-2 mb-1.5" data-id="element-38">
                  <span className="shrink-0 w-6 h-6 bg-primary text-white rounded-md flex items-center justify-center text-[10px] font-bold mt-0.5" data-id="element-39">
                    #{bonus.num}
                  </span>
                  <h4 className="text-sm md:text-base font-bold text-text-primary uppercase tracking-tight leading-tight" data-id="element-40">
                    {bonus.title}
                  </h4>
                </div>

                {/* Description */}
                <p className="text-[11px] md:text-xs text-text-secondary mb-2 leading-relaxed font-medium" data-id="element-41">
                  {bonus.desc}
                </p>

                {/* Price Tag */}
                <div className="flex flex-wrap items-center gap-1.5" data-id="element-42">
                  <span className="inline-flex items-center bg-danger/10 text-danger px-1.5 py-0.5 rounded text-[9px] md:text-[10px] font-bold line-through" data-id="element-43">
                    Valor {bonus.value.toLocaleString('es-AR')} ARS
                  </span>
                  <span className="inline-flex items-center bg-primary/10 text-primary px-1.5 py-0.5 rounded text-[9px] md:text-[10px] font-bold uppercase tracking-wide" data-id="element-44">
                    ¡GRATIS!
                  </span>
                </div>
              </div>
            </div>)}
        </div>

        {/* Total Value + CTA */}
        <div className="bg-white p-4 md:p-6 border border-black/10 text-center text-text-primary rounded-2xl shadow-sm" data-id="element-45">
          <p className="text-[10px] md:text-xs text-text-primary/60 font-bold mb-1 uppercase tracking-widest" data-id="element-46">
            VALOR TOTAL REAL
          </p>
          <p className="text-lg md:text-xl text-danger line-through mb-3 md:mb-4 font-bold" data-id="element-47">
            $144.930 ARS
          </p>

          <p className="text-sm md:text-base text-text-primary font-bold mb-1.5 md:mb-2" data-id="element-48">
            Hoy lo obtenés todo por solo:
          </p>
          <div className="mb-3 md:mb-4" data-id="element-49">
            <PriceDisplay amount={19990} className="text-2xl md:text-4xl font-black text-primary tracking-tight" data-id="element-50" />
          </div>

          <p className="text-text-primary/80 font-bold mb-4 md:mb-5 text-[10px] md:text-xs uppercase tracking-wide" data-id="element-51">
            Pago único. Sin membresías. Sin cargos ocultos.
          </p>

          <CTAButton large data-id="element-52">QUIERO MI SISTEMA 15D</CTAButton>
          <p className="text-[10px] md:text-xs text-text-primary/60 mt-2 md:mt-3 font-bold uppercase tracking-wide" data-id="element-53">
            Acceso inmediato · Descarga digital
          </p>
        </div>
      </div>
    </section>;
}